const path1 = {
  "1324": { x: 341, y: 74 },
  "1336": { x: 341, y: 74 },
  "1353": { x: 341, y: 75 },
  "1370": { x: 341, y: 75 },
  "1386": { x: 341, y: 75 },
  "1403": { x: 341, y: 75 },
  "1419": { x: 341, y: 76 },
  "1437": { x: 341, y: 76 },
  "1453": { x: 341, y: 76 },
  "1470": { x: 341, y: 76 },
  "1486": { x: 341, y: 77 },
  "1550": { x: 341, y: 77 },
  "1565": { x: 341, y: 77 },
  "1581": { x: 341, y: 77 },
  "1589": { x: 341, y: 78 },
  "1636": { x: 341, y: 78 },
  "1653": { x: 342, y: 78 },
  "1671": { x: 342, y: 78 },
  "1687": { x: 342, y: 78 },
  "1719": { x: 342, y: 78 },
  "1751": { x: 342, y: 78 },
  "1759": { x: 342, y: 78 },
  "1775": { x: 342, y: 78 },
  "1799": { x: 343, y: 78 },
  "1837": { x: 343, y: 79 },
  "1864": { x: 343, y: 79 },
  "1880": { x: 343, y: 79 },
  "1888": { x: 343, y: 79 },
  "1904": { x: 343, y: 80 },
  "1920": { x: 343, y: 80 },
  "2034": { x: 343, y: 80 },
  "2049": { x: 343, y: 80 },
  "2066": { x: 343, y: 80 },
  "2074": { x: 343, y: 80 },
  "2098": { x: 343, y: 80 },
  "2139": { x: 343, y: 80 },
  "2187": { x: 343, y: 80 },
  "2252": { x: 343, y: 81 },
  "2267": { x: 343, y: 81 },
  "2275": { x: 343, y: 81 },
  "2292": { x: 343, y: 81 },
  "2307": { x: 343, y: 81 },
  "2323": { x: 343, y: 81 },
  "2339": { x: 344, y: 81 },
  "2353": { x: 344, y: 81 },
  "2371": { x: 344, y: 81 },
  "2389": { x: 344, y: 81 },
  "2412": { x: 344, y: 81 },
  "2452": { x: 344, y: 82 },
  "2470": { x: 344, y: 82 },
  "2487": { x: 344, y: 82 },
  "2504": { x: 345, y: 83 },
  "2521": { x: 345, y: 83 },
  "2538": { x: 345, y: 83 },
  "2554": { x: 345, y: 83 },
  "2571": { x: 345, y: 83 },
  "2587": { x: 345, y: 83 },
  "2604": { x: 345, y: 83 },
  "2621": { x: 345, y: 84 },
  "2637": { x: 345, y: 84 },
  "2654": { x: 345, y: 84 },
  "2670": { x: 345, y: 84 },
  "2686": { x: 345, y: 85 },
  "2704": { x: 345, y: 85 },
  "2720": { x: 345, y: 85 },
  "2736": { x: 345, y: 85 },
  "2754": { x: 345, y: 85 },
  "2769": { x: 346, y: 85 },
  "2787": { x: 346, y: 85 },
  "2804": { x: 346, y: 86 },
  "2820": { x: 346, y: 86 },
  "2838": { x: 346, y: 86 },
  "2856": { x: 346, y: 86 },
  "2873": { x: 346, y: 86 },
  "2889": { x: 346, y: 86 },
  "2913": { x: 346, y: 86 },
  "2921": { x: 346, y: 86 },
  "2937": { x: 346, y: 86 },
  "2953": { x: 346, y: 87 },
  "2970": { x: 346, y: 87 },
  "2994": { x: 346, y: 87 },
  "3018": { x: 346, y: 87 },
  "3054": { x: 346, y: 88 },
  "3069": { x: 346, y: 88 },
  "3087": { x: 347, y: 88 },
  "3104": { x: 347, y: 88 },
  "3122": { x: 347, y: 88 },
  "3137": { x: 348, y: 88 },
  "3154": { x: 348, y: 89 },
  "3171": { x: 348, y: 89 },
  "3187": { x: 348, y: 90 },
  "3203": { x: 348, y: 90 },
  "3221": { x: 348, y: 90 },
  "3238": { x: 348, y: 90 },
  "3255": { x: 348, y: 91 },
  "3270": { x: 349, y: 91 },
  "3288": { x: 349, y: 91 },
  "3305": { x: 349, y: 91 },
  "3321": { x: 349, y: 91 },
  "3338": { x: 349, y: 92 },
  "3355": { x: 349, y: 92 },
  "3373": { x: 349, y: 92 },
  "3420": { x: 350, y: 92 },
  "3438": { x: 350, y: 93 },
  "3454": { x: 350, y: 93 },
  "3470": { x: 350, y: 93 },
  "3488": { x: 350, y: 93 },
  "3504": { x: 350, y: 93 },
  "3520": { x: 350, y: 93 },
  "3537": { x: 350, y: 93 },
  "3555": { x: 350, y: 94 },
  "3571": { x: 350, y: 94 },
  "3589": { x: 350, y: 94 },
  "3604": { x: 350, y: 95 },
  "3620": { x: 350, y: 95 },
  "3638": { x: 350, y: 95 },
  "3654": { x: 351, y: 95 },
  "3670": { x: 351, y: 95 },
  "3687": { x: 351, y: 96 },
  "3704": { x: 351, y: 96 },
  "3721": { x: 351, y: 96 },
  "3737": { x: 351, y: 97 },
  "3754": { x: 351, y: 97 },
  "3771": { x: 351, y: 98 },
  "3787": { x: 351, y: 98 },
  "3805": { x: 351, y: 98 },
  "3820": { x: 351, y: 98 },
  "3838": { x: 351, y: 99 },
  "3854": { x: 351, y: 100 },
  "3871": { x: 351, y: 100 },
  "3888": { x: 351, y: 100 },
  "3904": { x: 351, y: 101 },
  "3921": { x: 351, y: 101 },
  "3937": { x: 351, y: 101 },
  "3954": { x: 351, y: 101 },
  "3971": { x: 352, y: 102 },
  "3995": { x: 352, y: 102 },
  "4043": { x: 352, y: 102 },
  "4059": { x: 352, y: 102 },
  "4071": { x: 352, y: 102 },
  "4087": { x: 352, y: 103 },
  "4104": { x: 352, y: 103 },
  "4121": { x: 353, y: 103 },
  "4138": { x: 353, y: 103 },
  "4156": { x: 353, y: 103 },
  "4180": { x: 353, y: 103 },
  "4196": { x: 353, y: 103 },
  "4204": { x: 353, y: 104 },
  "4220": { x: 353, y: 104 },
  "4237": { x: 353, y: 105 },
  "4253": { x: 353, y: 105 },
  "4271": { x: 353, y: 106 },
  "4288": { x: 353, y: 106 },
  "4304": { x: 353, y: 106 },
  "4321": { x: 353, y: 107 },
  "4337": { x: 353, y: 107 },
  "4355": { x: 353, y: 108 },
  "4371": { x: 353, y: 108 },
  "4389": { x: 353, y: 108 },
  "4405": { x: 354, y: 109 },
  "4421": { x: 354, y: 109 },
  "4479": { x: 354, y: 109 },
  "4495": { x: 354, y: 110 },
  "4505": { x: 354, y: 110 },
  "4522": { x: 354, y: 110 },
  "4538": { x: 354, y: 110 },
  "4554": { x: 355, y: 110 },
  "4572": { x: 355, y: 111 },
  "4588": { x: 355, y: 111 },
  "4604": { x: 355, y: 111 },
  "4622": { x: 355, y: 111 },
  "4639": { x: 355, y: 111 },
  "4705": { x: 355, y: 111 },
  "4721": { x: 355, y: 111 },
  "4739": { x: 355, y: 111 },
  "4755": { x: 355, y: 111 },
  "4772": { x: 355, y: 111 },
  "4788": { x: 355, y: 111 },
  "4806": { x: 355, y: 111 },
  "4822": { x: 356, y: 112 },
  "4838": { x: 356, y: 112 },
  "4856": { x: 356, y: 112 },
  "4870": { x: 356, y: 112 },
  "4888": { x: 356, y: 113 },
  "4904": { x: 356, y: 113 },
  "4921": { x: 356, y: 113 },
  "4937": { x: 356, y: 113 },
  "4954": { x: 356, y: 114 },
  "4971": { x: 357, y: 114 },
  "4988": { x: 357, y: 115 },
  "5005": { x: 357, y: 115 },
  "5022": { x: 358, y: 115 },
  "5038": { x: 358, y: 116 },
  "5058": { x: 358, y: 116 },
  "5072": { x: 358, y: 116 },
  "5089": { x: 358, y: 116 },
  "5104": { x: 358, y: 116 },
  "5122": { x: 358, y: 117 },
  "5139": { x: 358, y: 117 },
  "5155": { x: 358, y: 117 },
  "5171": { x: 358, y: 117 },
  "5188": { x: 359, y: 118 },
  "5204": { x: 359, y: 118 },
  "5221": { x: 359, y: 118 },
  "5237": { x: 359, y: 118 },
  "5255": { x: 359, y: 118 },
  "5270": { x: 359, y: 119 },
  "5289": { x: 359, y: 119 },
  "5305": { x: 359, y: 120 },
  "5321": { x: 360, y: 120 },
  "5339": { x: 360, y: 120 },
  "5354": { x: 360, y: 120 },
  "5372": { x: 360, y: 120 },
  "5388": { x: 360, y: 121 },
  "5405": { x: 360, y: 121 },
  "5422": { x: 360, y: 121 },
  "5438": { x: 360, y: 121 },
  "5455": { x: 360, y: 121 },
  "5471": { x: 360, y: 122 },
  "5487": { x: 361, y: 122 },
  "5504": { x: 361, y: 123 },
  "5521": { x: 361, y: 123 },
  "5538": { x: 361, y: 123 },
  "5555": { x: 361, y: 123 },
  "5572": { x: 361, y: 124 },
  "5593": { x: 361, y: 124 },
  "5609": { x: 361, y: 124 },
  "5625": { x: 361, y: 125 },
  "5641": { x: 361, y: 125 },
  "5658": { x: 361, y: 125 },
  "5681": { x: 361, y: 125 },
  "5723": { x: 361, y: 125 },
  "5738": { x: 361, y: 125 },
  "5755": { x: 361, y: 125 },
  "5771": { x: 361, y: 126 },
  "5789": { x: 361, y: 126 },
  "5804": { x: 362, y: 126 },
  "5822": { x: 362, y: 126 },
  "5838": { x: 362, y: 126 },
  "5856": { x: 362, y: 126 },
  "5873": { x: 362, y: 126 },
  "5891": { x: 362, y: 126 },
  "5906": { x: 362, y: 126 },
  "5922": { x: 362, y: 127 },
  "5938": { x: 363, y: 127 },
  "5956": { x: 363, y: 127 },
  "5972": { x: 363, y: 127 },
  "5989": { x: 363, y: 127 },
  "6012": { x: 363, y: 127 },
  "6110": { x: 363, y: 127 },
  "7612": { x: 363, y: 127 },
  "7623": { x: 363, y: 128 },
  "7639": { x: 363, y: 128 },
  "7658": { x: 363, y: 128 },
  "7675": { x: 363, y: 128 },
  "7722": { x: 363, y: 128 },
  "7749": { x: 363, y: 128 },
  "7756": { x: 363, y: 128 },
  "7772": { x: 363, y: 128 },
  "7788": { x: 363, y: 128 },
  "7806": { x: 363, y: 129 },
  "7823": { x: 363, y: 129 },
  "7840": { x: 363, y: 129 },
  "7856": { x: 363, y: 129 },
  "7873": { x: 364, y: 130 },
  "7890": { x: 364, y: 130 },
  "7907": { x: 364, y: 130 },
  "7922": { x: 364, y: 130 },
  "7939": { x: 364, y: 130 },
  "7956": { x: 364, y: 130 },
  "7972": { x: 365, y: 131 },
  "7989": { x: 365, y: 131 },
  "8006": { x: 365, y: 131 },
  "8023": { x: 365, y: 131 },
  "8039": { x: 365, y: 131 },
  "8056": { x: 365, y: 131 },
  "8073": { x: 365, y: 131 },
  "8090": { x: 365, y: 132 },
  "8106": { x: 365, y: 132 },
  "8127": { x: 365, y: 132 },
  "8140": { x: 365, y: 132 },
  "8156": { x: 365, y: 132 },
  "8175": { x: 365, y: 133 },
  "8192": { x: 365, y: 133 },
  "8224": { x: 366, y: 133 },
  "8239": { x: 366, y: 133 },
  "8264": { x: 366, y: 133 },
  "8306": { x: 366, y: 133 },
  "8356": { x: 366, y: 133 },
  "8385": { x: 366, y: 133 },
  "8402": { x: 366, y: 133 },
  "8410": { x: 366, y: 133 },
  "8434": { x: 366, y: 133 },
  "8450": { x: 366, y: 133 },
  "8458": { x: 366, y: 133 },
  "8473": { x: 366, y: 133 },
  "8489": { x: 367, y: 133 },
  "8506": { x: 367, y: 133 },
  "8523": { x: 368, y: 133 },
  "8539": { x: 368, y: 133 },
  "8557": { x: 368, y: 133 },
  "8574": { x: 368, y: 133 },
  "8590": { x: 369, y: 133 },
  "8606": { x: 369, y: 133 },
  "8623": { x: 370, y: 133 },
  "8640": { x: 370, y: 133 },
  "8656": { x: 370, y: 133 },
  "8674": { x: 370, y: 133 },
  "8691": { x: 370, y: 133 },
  "8706": { x: 371, y: 133 },
  "8723": { x: 371, y: 133 },
  "8740": { x: 371, y: 133 },
  "8756": { x: 371, y: 133 },
  "8772": { x: 372, y: 132 },
  "8789": { x: 373, y: 132 },
  "8807": { x: 373, y: 132 },
  "8823": { x: 373, y: 131 },
  "8840": { x: 373, y: 131 },
  "8856": { x: 373, y: 131 },
  "8874": { x: 374, y: 131 },
  "8890": { x: 374, y: 131 },
  "8907": { x: 375, y: 131 },
  "8922": { x: 375, y: 131 },
  "8940": { x: 375, y: 131 },
  "8957": { x: 375, y: 130 },
  "8973": { x: 375, y: 130 },
  "8989": { x: 375, y: 130 },
  "9007": { x: 375, y: 130 },
  "9023": { x: 375, y: 130 },
  "9047": { x: 375, y: 130 },
  "9090": { x: 375, y: 130 },
  "9120": { x: 375, y: 130 },
  "9128": { x: 375, y: 130 },
  "9144": { x: 376, y: 130 },
  "9168": { x: 376, y: 130 },
  "9185": { x: 376, y: 130 },
  "9201": { x: 376, y: 130 },
  "9209": { x: 376, y: 130 },
  "9225": { x: 376, y: 130 },
  "9240": { x: 376, y: 130 },
  "9256": { x: 376, y: 129 },
  "9273": { x: 377, y: 129 },
  "9291": { x: 378, y: 129 },
  "9306": { x: 378, y: 129 },
  "9387": { x: 378, y: 129 },
  "9424": { x: 378, y: 129 },
  "9475": { x: 378, y: 128 },
  "9532": { x: 378, y: 128 },
  "9574": { x: 378, y: 128 },
  "9589": { x: 378, y: 128 },
  "9607": { x: 378, y: 128 },
  "9623": { x: 378, y: 128 },
  "9641": { x: 378, y: 128 },
  "9657": { x: 378, y: 128 },
  "9674": { x: 378, y: 127 },
  "9690": { x: 378, y: 127 },
  "9708": { x: 378, y: 127 },
  "9724": { x: 378, y: 127 },
  "9740": { x: 378, y: 126 },
  "9758": { x: 378, y: 126 },
  "9806": { x: 378, y: 126 },
  "9823": { x: 378, y: 126 },
  "9840": { x: 378, y: 126 },
  "9863": { x: 378, y: 126 },
  "9879": { x: 378, y: 126 },
  "9889": { x: 378, y: 126 },
  "9907": { x: 378, y: 126 },
  "9923": { x: 378, y: 125 },
  "9940": { x: 378, y: 125 },
  "9958": { x: 378, y: 125 },
  "9974": { x: 378, y: 125 },
  "9990": { x: 378, y: 125 },
  "10007": { x: 378, y: 125 },
  "10032": { x: 378, y: 124 },
  "10056": { x: 378, y: 124 },
  "10074": { x: 378, y: 124 },
  "10090": { x: 378, y: 124 },
  "10107": { x: 378, y: 123 },
  "10124": { x: 378, y: 123 },
  "10141": { x: 378, y: 123 },
  "10158": { x: 378, y: 123 },
  "10174": { x: 378, y: 123 },
  "10191": { x: 378, y: 123 },
  "10208": { x: 378, y: 122 },
  "10226": { x: 378, y: 122 },
  "10291": { x: 378, y: 122 },
  "10315": { x: 378, y: 122 },
  "10339": { x: 378, y: 121 },
  "10347": { x: 378, y: 121 },
  "10356": { x: 378, y: 121 },
  "10373": { x: 378, y: 121 },
  "10391": { x: 378, y: 120 },
  "10407": { x: 378, y: 120 },
  "10423": { x: 378, y: 120 },
  "10441": { x: 378, y: 119 },
  "10458": { x: 378, y: 119 },
  "10474": { x: 378, y: 119 },
  "10492": { x: 378, y: 119 },
  "10572": { x: 378, y: 118 },
  "10608": { x: 378, y: 118 },
  "10624": { x: 378, y: 118 },
  "10641": { x: 378, y: 117 },
  "10657": { x: 378, y: 117 },
  "10673": { x: 378, y: 116 },
  "10702": { x: 378, y: 116 },
  "10741": { x: 378, y: 116 },
  "10758": { x: 378, y: 116 },
  "10774": { x: 378, y: 116 },
  "10791": { x: 378, y: 116 },
  "10807": { x: 378, y: 115 },
  "10825": { x: 378, y: 115 },
  "10841": { x: 378, y: 115 },
  "10858": { x: 378, y: 114 },
  "10874": { x: 378, y: 114 },
  "10890": { x: 378, y: 113 },
  "10908": { x: 378, y: 113 },
  "10924": { x: 378, y: 112 },
  "10941": { x: 378, y: 111 },
  "10957": { x: 378, y: 111 },
  "10975": { x: 378, y: 111 },
  "10991": { x: 378, y: 111 },
  "11007": { x: 378, y: 110 },
  "11025": { x: 377, y: 110 },
  "11040": { x: 377, y: 110 },
  "11058": { x: 377, y: 110 },
  "11074": { x: 377, y: 110 },
  "11091": { x: 377, y: 110 },
  "11107": { x: 377, y: 110 },
  "11125": { x: 377, y: 109 },
  "11141": { x: 377, y: 109 },
  "11158": { x: 377, y: 108 },
  "11174": { x: 377, y: 108 },
  "11192": { x: 376, y: 106 },
  "11208": { x: 376, y: 106 },
  "11225": { x: 376, y: 105 },
  "11241": { x: 376, y: 105 },
  "11290": { x: 376, y: 105 },
  "11307": { x: 376, y: 105 },
  "11388": { x: 376, y: 105 },
  "11425": { x: 376, y: 105 },
  "11442": { x: 376, y: 105 },
  "11457": { x: 376, y: 104 },
  "11474": { x: 376, y: 104 },
  "11491": { x: 376, y: 103 },
  "11507": { x: 376, y: 103 },
  "11524": { x: 376, y: 103 },
  "11540": { x: 376, y: 102 },
  "11557": { x: 376, y: 102 },
  "11575": { x: 376, y: 101 },
  "11591": { x: 376, y: 101 },
  "11608": { x: 376, y: 101 },
  "11624": { x: 376, y: 101 },
  "11641": { x: 376, y: 101 },
  "11657": { x: 376, y: 100 },
  "11674": { x: 376, y: 100 },
  "11691": { x: 376, y: 100 },
  "11708": { x: 376, y: 100 },
  "11725": { x: 376, y: 100 },
  "11742": { x: 376, y: 99 },
  "11758": { x: 376, y: 99 },
  "11774": { x: 376, y: 99 },
  "11791": { x: 376, y: 99 },
  "11808": { x: 376, y: 98 },
  "11823": { x: 376, y: 98 },
  "11842": { x: 376, y: 98 },
  "11858": { x: 376, y: 98 },
  "11874": { x: 376, y: 98 },
  "11891": { x: 376, y: 98 },
  "11908": { x: 376, y: 97 },
  "11925": { x: 376, y: 97 },
  "11941": { x: 376, y: 96 },
  "11959": { x: 376, y: 96 },
  "11974": { x: 376, y: 96 },
  "11992": { x: 376, y: 96 },
  "12008": { x: 376, y: 95 },
  "12024": { x: 376, y: 95 },
  "12041": { x: 376, y: 95 },
  "12057": { x: 376, y: 95 },
  "12074": { x: 376, y: 95 },
  "12091": { x: 376, y: 94 },
  "12110": { x: 376, y: 94 },
  "12125": { x: 376, y: 94 },
  "12143": { x: 376, y: 93 },
  "12158": { x: 376, y: 93 },
  "12174": { x: 376, y: 93 },
  "12191": { x: 376, y: 92 },
  "12208": { x: 376, y: 92 },
  "12225": { x: 376, y: 91 },
  "12242": { x: 376, y: 91 },
  "12258": { x: 376, y: 90 },
  "12274": { x: 376, y: 90 },
  "12290": { x: 376, y: 89 },
  "12307": { x: 376, y: 89 },
  "12332": { x: 376, y: 88 },
  "12375": { x: 376, y: 88 },
  "12391": { x: 376, y: 88 },
  "12408": { x: 376, y: 88 },
  "12429": { x: 376, y: 88 },
  "12453": { x: 376, y: 88 },
  "12470": { x: 376, y: 88 },
  "12477": { x: 376, y: 88 },
  "12492": { x: 376, y: 88 },
  "12508": { x: 376, y: 87 },
  "12525": { x: 376, y: 87 },
  "12541": { x: 376, y: 86 },
  "12558": { x: 376, y: 86 },
  "12575": { x: 376, y: 86 },
  "12591": { x: 376, y: 85 },
  "12608": { x: 376, y: 85 },
  "12625": { x: 376, y: 85 },
  "12641": { x: 376, y: 85 },
  "12658": { x: 376, y: 84 },
  "12675": { x: 376, y: 84 },
  "12691": { x: 376, y: 83 },
  "12708": { x: 376, y: 83 },
  "12725": { x: 376, y: 83 },
  "12741": { x: 376, y: 83 },
  "12759": { x: 376, y: 83 },
  "12775": { x: 376, y: 82 },
  "12791": { x: 376, y: 82 },
  "12808": { x: 376, y: 82 },
  "12825": { x: 376, y: 81 },
  "12841": { x: 376, y: 81 },
  "12873": { x: 376, y: 81 },
  "12909": { x: 376, y: 81 },
  "12925": { x: 376, y: 81 },
  "12944": { x: 376, y: 81 },
  "12958": { x: 376, y: 80 },
  "12975": { x: 376, y: 80 },
  "12992": { x: 376, y: 80 },
  "13009": { x: 376, y: 80 },
  "13024": { x: 376, y: 80 },
  "13042": { x: 376, y: 80 },
  "13058": { x: 376, y: 80 },
  "13075": { x: 376, y: 79 },
  "13091": { x: 376, y: 79 },
  "13109": { x: 376, y: 79 },
  "13125": { x: 376, y: 78 },
  "13141": { x: 376, y: 78 },
  "13157": { x: 376, y: 78 },
  "13175": { x: 376, y: 78 },
  "13196": { x: 375, y: 78 },
  "13212": { x: 375, y: 78 },
  "13225": { x: 375, y: 78 },
  "13242": { x: 375, y: 78 },
  "13259": { x: 375, y: 78 },
  "13275": { x: 375, y: 78 },
  "13325": { x: 375, y: 77 },
  "13342": { x: 375, y: 77 },
  "13358": { x: 375, y: 77 },
  "13374": { x: 375, y: 77 },
  "13391": { x: 375, y: 76 },
  "13408": { x: 375, y: 76 },
  "13425": { x: 375, y: 76 },
  "13442": { x: 375, y: 76 },
  "13458": { x: 375, y: 76 },
  "13475": { x: 374, y: 76 },
  "13492": { x: 374, y: 76 },
  "13509": { x: 374, y: 75 },
  "13526": { x: 374, y: 75 },
  "13542": { x: 374, y: 75 },
  "13558": { x: 374, y: 75 },
  "13577": { x: 374, y: 74 },
  "13592": { x: 374, y: 74 }
};

const path2 = {
  "616": { x: 298, y: 444 },
  "633": { x: 298, y: 444 },
  "649": { x: 298, y: 445 },
  "680": { x: 298, y: 445 },
  "703": { x: 298, y: 445 },
  "719": { x: 298, y: 445 },
  "730": { x: 298, y: 445 },
  "747": { x: 298, y: 445 },
  "763": { x: 298, y: 445 },
  "780": { x: 298, y: 446 },
  "873": { x: 298, y: 446 },
  "889": { x: 298, y: 446 },
  "930": { x: 298, y: 446 },
  "1148": { x: 298, y: 446 },
  "1164": { x: 298, y: 446 },
  "1180": { x: 298, y: 446 },
  "1230": { x: 298, y: 446 },
  "1252": { x: 298, y: 446 },
  "1263": { x: 298, y: 446 },
  "1285": { x: 298, y: 447 },
  "1414": { x: 298, y: 447 },
  "1430": { x: 298, y: 447 },
  "1575": { x: 298, y: 447 },
  "1592": { x: 298, y: 448 },
  "1630": { x: 298, y: 448 },
  "1648": { x: 298, y: 448 },
  "1664": { x: 298, y: 448 },
  "1679": { x: 298, y: 448 },
  "1697": { x: 298, y: 448 },
  "1714": { x: 298, y: 448 },
  "1731": { x: 298, y: 449 },
  "1747": { x: 298, y: 449 },
  "1763": { x: 298, y: 449 },
  "1781": { x: 298, y: 450 },
  "1802": { x: 298, y: 450 },
  "1817": { x: 297, y: 450 },
  "1862": { x: 297, y: 450 },
  "1880": { x: 297, y: 450 },
  "1897": { x: 297, y: 450 },
  "1914": { x: 297, y: 450 },
  "1930": { x: 297, y: 450 },
  "1947": { x: 297, y: 450 },
  "1998": { x: 297, y: 450 },
  "4058": { x: 297, y: 450 },
  "4073": { x: 297, y: 451 },
  "4090": { x: 297, y: 451 },
  "4114": { x: 297, y: 451 },
  "4166": { x: 297, y: 451 },
  "4194": { x: 297, y: 451 },
  "4210": { x: 297, y: 451 },
  "4249": { x: 297, y: 451 },
  "4265": { x: 297, y: 451 },
  "4281": { x: 297, y: 451 },
  "4298": { x: 297, y: 452 },
  "4315": { x: 296, y: 452 },
  "4331": { x: 296, y: 453 },
  "4348": { x: 296, y: 453 },
  "4365": { x: 296, y: 453 },
  "4382": { x: 296, y: 453 },
  "4399": { x: 296, y: 453 },
  "4415": { x: 296, y: 453 },
  "4432": { x: 296, y: 454 },
  "4448": { x: 295, y: 455 },
  "4466": { x: 295, y: 455 },
  "4482": { x: 295, y: 455 },
  "4498": { x: 295, y: 455 },
  "4516": { x: 295, y: 455 },
  "4532": { x: 295, y: 455 },
  "4558": { x: 295, y: 456 },
  "4566": { x: 295, y: 456 },
  "4615": { x: 295, y: 456 },
  "4631": { x: 295, y: 456 },
  "4654": { x: 295, y: 456 },
  "4671": { x: 295, y: 456 },
  "4716": { x: 295, y: 456 },
  "4732": { x: 295, y: 456 },
  "4749": { x: 295, y: 456 },
  "4766": { x: 295, y: 456 },
  "4782": { x: 295, y: 456 },
  "4799": { x: 295, y: 457 },
  "4816": { x: 294, y: 457 },
  "4832": { x: 294, y: 457 },
  "4848": { x: 294, y: 457 },
  "4865": { x: 294, y: 458 },
  "4882": { x: 294, y: 458 },
  "4898": { x: 294, y: 458 },
  "4922": { x: 294, y: 458 },
  "4932": { x: 294, y: 458 },
  "4953": { x: 294, y: 458 },
  "4969": { x: 294, y: 458 },
  "4985": { x: 293, y: 458 },
  "5002": { x: 293, y: 458 },
  "5015": { x: 293, y: 459 },
  "5032": { x: 293, y: 459 },
  "5048": { x: 293, y: 459 },
  "5065": { x: 293, y: 459 },
  "5115": { x: 293, y: 460 },
  "5147": { x: 293, y: 460 },
  "5163": { x: 293, y: 460 },
  "5171": { x: 293, y: 460 },
  "5182": { x: 293, y: 460 },
  "5198": { x: 293, y: 460 },
  "5215": { x: 293, y: 460 },
  "5232": { x: 293, y: 460 },
  "5249": { x: 293, y: 460 },
  "5265": { x: 293, y: 461 },
  "5284": { x: 293, y: 461 },
  "5300": { x: 293, y: 461 },
  "5316": { x: 293, y: 461 },
  "5332": { x: 293, y: 461 },
  "5348": { x: 292, y: 461 },
  "5365": { x: 292, y: 461 },
  "5381": { x: 292, y: 462 },
  "5399": { x: 292, y: 462 },
  "5416": { x: 292, y: 462 },
  "5437": { x: 292, y: 462 },
  "5448": { x: 292, y: 462 },
  "5465": { x: 292, y: 463 },
  "5483": { x: 291, y: 463 },
  "5499": { x: 291, y: 463 },
  "5515": { x: 291, y: 463 },
  "5534": { x: 291, y: 463 },
  "5582": { x: 291, y: 463 },
  "5599": { x: 291, y: 463 },
  "5614": { x: 291, y: 463 },
  "5635": { x: 291, y: 464 },
  "5649": { x: 291, y: 464 },
  "5666": { x: 291, y: 464 },
  "5682": { x: 291, y: 464 },
  "5704": { x: 291, y: 464 },
  "5748": { x: 291, y: 465 },
  "5776": { x: 291, y: 465 },
  "5785": { x: 291, y: 465 },
  "5801": { x: 291, y: 465 },
  "5825": { x: 291, y: 465 },
  "5833": { x: 291, y: 465 },
  "5849": { x: 291, y: 465 },
  "5865": { x: 291, y: 465 },
  "5922": { x: 291, y: 465 },
  "5946": { x: 291, y: 465 },
  "5962": { x: 291, y: 465 },
  "5978": { x: 291, y: 466 },
  "5986": { x: 290, y: 466 },
  "6000": { x: 290, y: 466 },
  "6016": { x: 290, y: 466 },
  "6033": { x: 290, y: 466 },
  "6049": { x: 290, y: 466 },
  "6116": { x: 290, y: 466 },
  "6148": { x: 290, y: 466 },
  "6172": { x: 290, y: 466 },
  "6196": { x: 290, y: 467 },
  "6233": { x: 290, y: 467 },
  "6250": { x: 290, y: 467 },
  "6268": { x: 290, y: 467 },
  "6285": { x: 290, y: 467 },
  "6300": { x: 290, y: 468 },
  "6316": { x: 290, y: 468 },
  "6332": { x: 290, y: 468 },
  "6348": { x: 290, y: 468 },
  "6366": { x: 290, y: 468 },
  "6382": { x: 290, y: 468 },
  "6400": { x: 290, y: 468 },
  "6416": { x: 290, y: 468 },
  "6432": { x: 290, y: 469 },
  "6462": { x: 290, y: 469 },
  "6470": { x: 290, y: 469 },
  "6516": { x: 290, y: 469 },
  "6544": { x: 290, y: 469 },
  "6745": { x: 290, y: 469 },
  "6802": { x: 290, y: 469 },
  "6816": { x: 290, y: 469 },
  "6842": { x: 290, y: 469 },
  "6858": { x: 290, y: 469 },
  "6874": { x: 290, y: 469 },
  "6915": { x: 290, y: 469 },
  "6979": { x: 290, y: 469 },
  "7060": { x: 290, y: 469 },
  "7100": { x: 291, y: 469 },
  "7124": { x: 291, y: 469 },
  "7147": { x: 291, y: 469 },
  "7166": { x: 291, y: 469 },
  "7182": { x: 291, y: 469 },
  "7200": { x: 291, y: 469 },
  "7216": { x: 291, y: 469 },
  "7232": { x: 291, y: 469 },
  "7249": { x: 291, y: 469 },
  "7278": { x: 291, y: 469 },
  "7285": { x: 292, y: 469 },
  "7350": { x: 292, y: 469 },
  "7366": { x: 292, y: 469 },
  "7399": { x: 292, y: 470 },
  "7422": { x: 292, y: 470 },
  "7438": { x: 292, y: 470 },
  "7449": { x: 293, y: 470 },
  "7479": { x: 293, y: 470 },
  "7486": { x: 293, y: 470 },
  "7511": { x: 293, y: 470 },
  "7521": { x: 293, y: 470 },
  "7536": { x: 293, y: 470 },
  "7553": { x: 293, y: 470 },
  "7566": { x: 293, y: 470 },
  "7582": { x: 293, y: 470 },
  "7600": { x: 293, y: 470 },
  "7615": { x: 293, y: 471 },
  "7632": { x: 294, y: 471 },
  "7649": { x: 294, y: 471 },
  "7667": { x: 295, y: 471 },
  "7683": { x: 295, y: 471 },
  "7700": { x: 295, y: 471 },
  "7721": { x: 295, y: 471 },
  "7737": { x: 295, y: 471 },
  "7749": { x: 295, y: 471 },
  "7799": { x: 295, y: 471 },
  "7850": { x: 295, y: 471 },
  "7874": { x: 295, y: 471 },
  "7899": { x: 295, y: 471 },
  "7923": { x: 296, y: 471 },
  "7967": { x: 296, y: 471 },
  "7983": { x: 296, y: 471 },
  "7999": { x: 296, y: 471 },
  "8016": { x: 296, y: 471 },
  "8033": { x: 296, y: 471 },
  "8050": { x: 296, y: 471 },
  "8099": { x: 296, y: 471 },
  "8116": { x: 296, y: 472 },
  "8141": { x: 296, y: 472 },
  "8190": { x: 297, y: 472 },
  "8234": { x: 297, y: 472 },
  "8254": { x: 297, y: 472 },
  "8279": { x: 297, y: 472 },
  "8295": { x: 297, y: 472 },
  "8311": { x: 298, y: 472 },
  "8350": { x: 298, y: 472 },
  "8375": { x: 298, y: 472 },
  "8400": { x: 298, y: 472 },
  "8417": { x: 298, y: 472 },
  "8440": { x: 298, y: 472 },
  "8456": { x: 298, y: 472 },
  "8472": { x: 298, y: 472 },
  "8488": { x: 298, y: 472 },
  "8505": { x: 299, y: 472 },
  "8521": { x: 299, y: 472 },
  "8537": { x: 299, y: 472 },
  "8552": { x: 299, y: 472 },
  "8569": { x: 300, y: 472 },
  "8585": { x: 300, y: 472 },
  "8601": { x: 300, y: 472 },
  "8616": { x: 300, y: 472 },
  "8633": { x: 300, y: 472 },
  "8650": { x: 300, y: 472 },
  "8682": { x: 300, y: 472 },
  "8715": { x: 300, y: 472 },
  "8722": { x: 300, y: 473 },
  "8747": { x: 300, y: 473 },
  "8763": { x: 301, y: 473 },
  "8801": { x: 301, y: 473 },
  "8817": { x: 301, y: 473 },
  "8834": { x: 301, y: 473 },
  "8850": { x: 301, y: 473 },
  "8867": { x: 301, y: 473 },
  "8884": { x: 301, y: 473 },
  "8900": { x: 301, y: 473 },
  "8924": { x: 301, y: 473 },
  "8934": { x: 301, y: 473 },
  "8951": { x: 302, y: 473 },
  "8966": { x: 302, y: 473 },
  "8989": { x: 302, y: 473 },
  "9013": { x: 302, y: 473 },
  "9050": { x: 302, y: 473 },
  "9070": { x: 303, y: 473 },
  "9117": { x: 303, y: 473 },
  "9167": { x: 303, y: 473 },
  "9191": { x: 303, y: 473 },
  "9234": { x: 303, y: 473 },
  "9296": { x: 303, y: 473 },
  "9377": { x: 303, y: 473 },
  "9441": { x: 303, y: 473 },
  "10677": { x: 303, y: 473 },
  "10683": { x: 303, y: 474 },
  "10716": { x: 303, y: 474 },
  "10750": { x: 303, y: 474 },
  "10975": { x: 303, y: 474 },
  "11018": { x: 303, y: 475 },
  "11047": { x: 303, y: 475 },
  "11104": { x: 303, y: 475 },
  "11151": { x: 303, y: 475 },
  "11168": { x: 303, y: 475 },
  "11218": { x: 303, y: 475 },
  "11235": { x: 303, y: 476 },
  "11251": { x: 303, y: 476 },
  "11268": { x: 303, y: 476 },
  "11284": { x: 303, y: 477 },
  "11302": { x: 303, y: 478 },
  "11318": { x: 303, y: 478 },
  "11334": { x: 303, y: 478 },
  "11352": { x: 303, y: 479 },
  "11368": { x: 303, y: 479 },
  "11384": { x: 303, y: 479 },
  "11467": { x: 303, y: 480 },
  "12331": { x: 303, y: 479 },
  "12525": { x: 303, y: 479 },
  "12573": { x: 303, y: 479 },
  "12619": { x: 303, y: 479 },
  "12645": { x: 303, y: 478 },
  "12684": { x: 303, y: 478 },
  "12702": { x: 303, y: 478 },
  "12718": { x: 303, y: 478 },
  "12735": { x: 303, y: 478 },
  "12751": { x: 303, y: 478 },
  "12769": { x: 303, y: 478 },
  "12799": { x: 303, y: 478 },
  "12838": { x: 303, y: 478 },
  "12863": { x: 303, y: 477 },
  "12879": { x: 304, y: 477 },
  "12896": { x: 304, y: 477 },
  "12935": { x: 304, y: 477 },
  "12951": { x: 304, y: 477 },
  "12969": { x: 304, y: 476 },
  "12984": { x: 304, y: 476 },
  "13002": { x: 304, y: 476 },
  "13018": { x: 304, y: 476 },
  "13036": { x: 304, y: 476 },
  "13052": { x: 304, y: 476 },
  "13069": { x: 304, y: 476 },
  "13085": { x: 304, y: 475 },
  "13102": { x: 304, y: 475 },
  "13118": { x: 304, y: 475 },
  "13136": { x: 304, y: 475 },
  "13152": { x: 304, y: 475 },
  "13168": { x: 304, y: 475 },
  "13186": { x: 304, y: 474 },
  "13203": { x: 304, y: 474 },
  "13218": { x: 304, y: 474 },
  "13242": { x: 304, y: 474 },
  "13267": { x: 304, y: 473 },
  "13282": { x: 304, y: 473 },
  "13299": { x: 304, y: 473 },
  "13315": { x: 304, y: 473 },
  "13331": { x: 304, y: 473 },
  "13339": { x: 304, y: 473 },
  "13355": { x: 304, y: 473 },
  "13370": { x: 304, y: 473 },
  "13386": { x: 304, y: 472 },
  "13402": { x: 304, y: 472 },
  "13418": { x: 304, y: 472 },
  "13435": { x: 304, y: 471 },
  "13451": { x: 304, y: 471 },
  "13469": { x: 304, y: 471 },
  "13485": { x: 304, y: 471 },
  "13502": { x: 304, y: 470 },
  "13518": { x: 304, y: 470 },
  "13536": { x: 304, y: 470 },
  "13551": { x: 304, y: 469 },
  "13569": { x: 304, y: 469 },
  "13585": { x: 304, y: 468 },
  "13602": { x: 304, y: 468 },
  "13619": { x: 304, y: 468 },
  "13636": { x: 304, y: 468 },
  "13654": { x: 304, y: 468 },
  "13905": { x: 304, y: 468 },
  "13929": { x: 304, y: 468 },
  "13969": { x: 304, y: 467 },
  "13985": { x: 304, y: 467 },
  "14002": { x: 304, y: 467 },
  "14018": { x: 304, y: 467 },
  "14037": { x: 304, y: 466 },
  "14053": { x: 304, y: 466 },
  "14070": { x: 304, y: 466 },
  "14086": { x: 304, y: 466 },
  "14102": { x: 304, y: 466 },
  "14119": { x: 304, y: 466 },
  "14136": { x: 304, y: 466 },
  "14155": { x: 304, y: 465 },
  "14169": { x: 304, y: 465 },
  "14186": { x: 304, y: 465 },
  "14202": { x: 304, y: 465 },
  "14219": { x: 304, y: 465 },
  "14235": { x: 304, y: 465 },
  "14252": { x: 304, y: 464 },
  "14269": { x: 304, y: 464 },
  "14286": { x: 304, y: 464 },
  "14303": { x: 305, y: 463 },
  "14324": { x: 305, y: 463 },
  "14341": { x: 305, y: 463 },
  "14387": { x: 305, y: 463 },
  "14404": { x: 305, y: 463 },
  "14419": { x: 305, y: 463 },
  "14436": { x: 305, y: 463 },
  "14453": { x: 305, y: 462 },
  "14470": { x: 305, y: 462 },
  "14486": { x: 305, y: 462 },
  "14502": { x: 305, y: 462 },
  "14518": { x: 305, y: 461 },
  "14537": { x: 305, y: 461 },
  "14553": { x: 305, y: 461 },
  "14569": { x: 305, y: 461 },
  "14587": { x: 305, y: 461 },
  "14603": { x: 305, y: 461 },
  "14623": { x: 305, y: 461 },
  "14647": { x: 305, y: 461 },
  "14655": { x: 305, y: 461 },
  "14671": { x: 305, y: 460 },
  "14695": { x: 305, y: 460 },
  "14736": { x: 305, y: 460 },
  "14752": { x: 305, y: 460 },
  "14769": { x: 305, y: 460 },
  "14800": { x: 305, y: 460 },
  "14836": { x: 305, y: 460 },
  "14853": { x: 305, y: 459 },
  "14869": { x: 305, y: 459 },
  "14889": { x: 305, y: 459 },
  "14903": { x: 305, y: 459 },
  "14920": { x: 305, y: 459 },
  "14937": { x: 305, y: 458 },
  "14954": { x: 305, y: 458 },
  "14970": { x: 305, y: 458 },
  "14987": { x: 305, y: 458 },
  "15002": { x: 305, y: 458 },
  "15026": { x: 305, y: 458 },
  "15042": { x: 305, y: 458 },
  "15052": { x: 305, y: 458 },
  "15069": { x: 305, y: 457 },
  "15087": { x: 305, y: 457 },
  "15103": { x: 305, y: 456 },
  "15119": { x: 305, y: 456 },
  "15137": { x: 305, y: 456 },
  "15153": { x: 306, y: 456 },
  "15170": { x: 306, y: 456 },
  "15186": { x: 306, y: 456 },
  "15204": { x: 306, y: 455 },
  "15228": { x: 306, y: 455 },
  "15244": { x: 306, y: 455 },
  "15262": { x: 306, y: 455 },
  "15284": { x: 306, y: 455 },
  "15301": { x: 306, y: 455 },
  "15309": { x: 306, y: 455 },
  "15319": { x: 306, y: 455 },
  "15337": { x: 306, y: 455 },
  "15357": { x: 306, y: 454 },
  "15403": { x: 306, y: 454 },
  "15453": { x: 306, y: 454 },
  "15470": { x: 306, y: 454 },
  "15486": { x: 306, y: 453 },
  "15511": { x: 306, y: 453 },
  "15535": { x: 306, y: 453 },
  "15544": { x: 306, y: 453 },
  "15567": { x: 306, y: 453 },
  "15615": { x: 306, y: 453 },
  "15653": { x: 306, y: 453 },
  "15672": { x: 306, y: 453 },
  "15688": { x: 306, y: 453 },
  "15704": { x: 306, y: 453 },
  "15753": { x: 306, y: 452 },
  "15771": { x: 306, y: 452 },
  "15801": { x: 306, y: 452 },
  "15837": { x: 306, y: 452 },
  "15865": { x: 306, y: 451 },
  "15947": { x: 306, y: 451 },
  "15987": { x: 306, y: 451 },
  "16037": { x: 306, y: 451 },
  "16060": { x: 306, y: 451 },
  "16084": { x: 306, y: 451 },
  "16133": { x: 306, y: 451 },
  "16171": { x: 306, y: 451 },
  "16187": { x: 306, y: 450 },
  "16205": { x: 306, y: 450 },
  "16229": { x: 306, y: 450 },
  "16271": { x: 306, y: 450 },
  "16293": { x: 306, y: 450 },
  "16337": { x: 306, y: 450 },
  "16354": { x: 306, y: 450 },
  "16407": { x: 306, y: 450 },
  "17655": { x: 306, y: 450 },
  "17670": { x: 306, y: 450 },
  "17688": { x: 306, y: 450 },
  "17703": { x: 306, y: 450 },
  "17726": { x: 306, y: 450 },
  "17751": { x: 306, y: 450 },
  "17791": { x: 306, y: 450 },
  "17838": { x: 306, y: 451 },
  "17864": { x: 306, y: 451 },
  "17904": { x: 306, y: 451 },
  "17921": { x: 306, y: 451 },
  "17938": { x: 306, y: 451 },
  "17954": { x: 306, y: 451 },
  "17972": { x: 306, y: 451 },
  "18001": { x: 306, y: 451 },
  "18058": { x: 306, y: 452 },
  "18104": { x: 306, y: 452 },
  "18120": { x: 306, y: 452 },
  "18171": { x: 306, y: 452 },
  "18194": { x: 306, y: 452 },
  "18210": { x: 306, y: 453 },
  "18220": { x: 306, y: 453 },
  "18238": { x: 306, y: 453 },
  "18254": { x: 306, y: 453 },
  "18271": { x: 306, y: 453 },
  "18288": { x: 306, y: 453 },
  "18305": { x: 306, y: 453 },
  "18322": { x: 306, y: 453 },
  "18348": { x: 306, y: 453 },
  "18372": { x: 306, y: 454 },
  "18388": { x: 306, y: 454 },
  "18404": { x: 306, y: 454 },
  "18422": { x: 306, y: 455 },
  "18438": { x: 306, y: 455 },
  "18455": { x: 306, y: 455 },
  "18471": { x: 306, y: 455 },
  "18488": { x: 306, y: 455 },
  "18518": { x: 305, y: 455 },
  "18566": { x: 305, y: 455 },
  "18605": { x: 305, y: 456 },
  "18621": { x: 305, y: 456 },
  "18637": { x: 305, y: 456 },
  "18654": { x: 305, y: 456 },
  "18672": { x: 305, y: 456 },
  "18687": { x: 305, y: 456 },
  "18719": { x: 305, y: 456 },
  "18726": { x: 305, y: 456 },
  "18738": { x: 305, y: 457 },
  "18754": { x: 305, y: 457 },
  "18772": { x: 305, y: 457 },
  "18788": { x: 305, y: 458 },
  "18805": { x: 305, y: 458 },
  "18821": { x: 305, y: 458 },
  "18840": { x: 305, y: 458 },
  "18857": { x: 305, y: 458 },
  "18873": { x: 305, y: 458 },
  "18888": { x: 305, y: 459 },
  "18904": { x: 305, y: 459 },
  "18921": { x: 305, y: 459 },
  "18938": { x: 305, y: 460 },
  "18955": { x: 305, y: 460 },
  "18971": { x: 305, y: 460 },
  "18988": { x: 305, y: 460 },
  "19005": { x: 305, y: 460 },
  "19021": { x: 305, y: 460 },
  "19041": { x: 305, y: 461 },
  "19057": { x: 305, y: 461 },
  "19082": { x: 305, y: 461 },
  "19098": { x: 305, y: 461 },
  "19115": { x: 305, y: 461 },
  "19131": { x: 305, y: 461 },
  "19171": { x: 305, y: 461 },
  "19188": { x: 305, y: 461 },
  "19205": { x: 305, y: 462 },
  "19221": { x: 305, y: 462 },
  "19238": { x: 305, y: 462 },
  "19255": { x: 305, y: 462 },
  "19271": { x: 305, y: 462 },
  "19300": { x: 305, y: 463 },
  "19337": { x: 305, y: 463 },
  "19355": { x: 304, y: 463 },
  "19371": { x: 304, y: 463 },
  "19389": { x: 304, y: 463 },
  "19438": { x: 304, y: 463 },
  "19455": { x: 304, y: 463 },
  "19472": { x: 304, y: 463 },
  "19494": { x: 304, y: 464 },
  "19509": { x: 304, y: 464 },
  "19534": { x: 304, y: 464 },
  "19542": { x: 304, y: 464 },
  "19554": { x: 304, y: 464 },
  "19572": { x: 304, y: 465 },
  "19588": { x: 304, y: 465 },
  "19605": { x: 304, y: 465 },
  "19623": { x: 304, y: 465 },
  "19639": { x: 304, y: 465 },
  "19687": { x: 304, y: 465 },
  "19704": { x: 304, y: 465 },
  "19722": { x: 304, y: 466 },
  "19739": { x: 304, y: 466 },
  "19756": { x: 304, y: 466 },
  "19772": { x: 304, y: 466 },
  "19789": { x: 304, y: 466 },
  "19805": { x: 304, y: 466 },
  "19825": { x: 304, y: 466 },
  "19841": { x: 304, y: 466 },
  "19865": { x: 304, y: 466 },
  "19881": { x: 304, y: 467 },
  "19922": { x: 304, y: 467 },
  "19938": { x: 304, y: 467 },
  "19955": { x: 304, y: 467 },
  "19972": { x: 304, y: 468 },
  "19994": { x: 304, y: 468 },
  "20019": { x: 304, y: 468 },
  "20055": { x: 304, y: 468 },
  "20083": { x: 304, y: 468 },
  "20124": { x: 304, y: 468 },
  "20147": { x: 304, y: 468 },
  "20164": { x: 304, y: 468 },
  "20180": { x: 304, y: 469 },
  "20196": { x: 304, y: 469 },
  "20205": { x: 304, y: 469 },
  "20221": { x: 304, y: 470 },
  "20238": { x: 304, y: 470 },
  "20254": { x: 304, y: 470 },
  "20272": { x: 304, y: 470 },
  "20288": { x: 304, y: 471 },
  "20305": { x: 304, y: 471 },
  "20322": { x: 304, y: 471 },
  "20339": { x: 303, y: 471 },
  "20356": { x: 303, y: 472 },
  "20372": { x: 303, y: 472 },
  "20390": { x: 303, y: 472 },
  "20414": { x: 303, y: 473 },
  "20455": { x: 303, y: 473 },
  "20479": { x: 303, y: 473 },
  "20523": { x: 303, y: 473 },
  "21109": { x: 304, y: 473 },
  "21155": { x: 304, y: 473 },
  "21181": { x: 304, y: 473 },
  "21223": { x: 304, y: 473 },
  "21239": { x: 305, y: 473 },
  "21255": { x: 305, y: 473 },
  "21273": { x: 305, y: 473 },
  "21289": { x: 305, y: 473 },
  "21310": { x: 305, y: 473 },
  "21326": { x: 305, y: 473 },
  "21342": { x: 305, y: 473 },
  "21356": { x: 305, y: 473 },
  "21373": { x: 305, y: 473 },
  "21389": { x: 306, y: 473 },
  "21406": { x: 306, y: 473 },
  "21423": { x: 306, y: 473 },
  "21439": { x: 306, y: 473 },
  "21456": { x: 306, y: 473 },
  "21480": { x: 306, y: 473 },
  "21496": { x: 306, y: 473 },
  "21512": { x: 306, y: 473 },
  "21536": { x: 307, y: 473 },
  "21573": { x: 307, y: 473 },
  "21589": { x: 307, y: 473 },
  "21606": { x: 307, y: 473 },
  "21622": { x: 308, y: 473 },
  "21639": { x: 308, y: 473 },
  "21655": { x: 308, y: 473 },
  "21672": { x: 308, y: 473 },
  "21689": { x: 308, y: 473 },
  "21706": { x: 308, y: 473 },
  "21722": { x: 309, y: 473 },
  "21739": { x: 309, y: 473 },
  "21756": { x: 309, y: 473 },
  "21772": { x: 310, y: 473 },
  "21789": { x: 310, y: 473 },
  "21807": { x: 310, y: 473 },
  "21823": { x: 310, y: 473 },
  "21839": { x: 311, y: 473 },
  "21856": { x: 311, y: 473 },
  "21872": { x: 311, y: 473 },
  "21890": { x: 311, y: 473 },
  "21906": { x: 312, y: 473 },
  "21922": { x: 312, y: 473 },
  "21940": { x: 312, y: 472 },
  "21990": { x: 313, y: 472 },
  "22012": { x: 313, y: 472 },
  "22037": { x: 313, y: 472 },
  "22073": { x: 313, y: 472 },
  "22090": { x: 313, y: 472 },
  "22106": { x: 313, y: 472 },
  "22125": { x: 313, y: 472 },
  "22141": { x: 313, y: 472 },
  "22189": { x: 314, y: 472 },
  "22206": { x: 314, y: 472 },
  "22223": { x: 315, y: 472 },
  "22239": { x: 315, y: 472 },
  "22256": { x: 315, y: 472 },
  "22272": { x: 315, y: 472 },
  "22290": { x: 315, y: 472 },
  "22306": { x: 316, y: 472 },
  "22323": { x: 316, y: 472 },
  "22343": { x: 316, y: 472 },
  "22390": { x: 316, y: 472 },
  "22440": { x: 316, y: 472 }
};

const path3 = {
  "1274": { x: 482, y: 170 },
  "1289": { x: 482, y: 170 },
  "1305": { x: 482, y: 171 },
  "1312": { x: 482, y: 171 },
  "1329": { x: 482, y: 171 },
  "1353": { x: 481, y: 171 },
  "1378": { x: 481, y: 172 },
  "1394": { x: 481, y: 172 },
  "1410": { x: 481, y: 172 },
  "1459": { x: 481, y: 172 },
  "1482": { x: 481, y: 172 },
  "1494": { x: 481, y: 173 },
  "1510": { x: 481, y: 173 },
  "1527": { x: 481, y: 173 },
  "1543": { x: 480, y: 173 },
  "1886": { x: 480, y: 173 },
  "1927": { x: 480, y: 173 },
  "1978": { x: 479, y: 173 },
  "2007": { x: 479, y: 173 },
  "2044": { x: 479, y: 173 },
  "2072": { x: 479, y: 173 },
  "2120": { x: 478, y: 173 },
  "2193": { x: 478, y: 173 },
  "2243": { x: 478, y: 173 },
  "2294": { x: 478, y: 173 },
  "2310": { x: 477, y: 173 },
  "2329": { x: 477, y: 173 },
  "2345": { x: 477, y: 174 },
  "2361": { x: 477, y: 174 },
  "2376": { x: 477, y: 174 },
  "2403": { x: 477, y: 174 },
  "2419": { x: 477, y: 174 },
  "2426": { x: 477, y: 174 },
  "2442": { x: 477, y: 175 },
  "2460": { x: 476, y: 175 },
  "2477": { x: 476, y: 175 },
  "2526": { x: 476, y: 175 },
  "2543": { x: 476, y: 175 },
  "2613": { x: 476, y: 175 },
  "2661": { x: 476, y: 175 },
  "2709": { x: 475, y: 175 },
  "2759": { x: 475, y: 176 },
  "2782": { x: 475, y: 176 },
  "2827": { x: 475, y: 176 },
  "2854": { x: 475, y: 176 },
  "2894": { x: 474, y: 176 },
  "2911": { x: 474, y: 176 },
  "2927": { x: 474, y: 176 },
  "3008": { x: 474, y: 176 },
  "3016": { x: 474, y: 176 },
  "3032": { x: 474, y: 177 },
  "3048": { x: 474, y: 177 },
  "3129": { x: 473, y: 177 },
  "3202": { x: 473, y: 177 },
  "3226": { x: 473, y: 177 },
  "3278": { x: 473, y: 177 },
  "3327": { x: 473, y: 177 },
  "4175": { x: 472, y: 177 },
  "4182": { x: 472, y: 177 },
  "4198": { x: 472, y: 177 },
  "4214": { x: 472, y: 177 },
  "4231": { x: 472, y: 178 },
  "4245": { x: 472, y: 178 },
  "4261": { x: 472, y: 178 },
  "4278": { x: 472, y: 178 },
  "4294": { x: 471, y: 178 },
  "4311": { x: 471, y: 178 },
  "4327": { x: 471, y: 179 },
  "4344": { x: 471, y: 179 },
  "4362": { x: 471, y: 179 },
  "4378": { x: 471, y: 179 },
  "4395": { x: 470, y: 179 },
  "4423": { x: 470, y: 179 },
  "4764": { x: 470, y: 180 },
  "4788": { x: 470, y: 180 },
  "4804": { x: 469, y: 180 },
  "4828": { x: 469, y: 180 },
  "4845": { x: 469, y: 180 },
  "4861": { x: 469, y: 180 },
  "4878": { x: 469, y: 181 },
  "4894": { x: 468, y: 181 },
  "4912": { x: 468, y: 181 },
  "4928": { x: 468, y: 181 },
  "5200": { x: 468, y: 181 },
  "5212": { x: 467, y: 181 },
  "5240": { x: 467, y: 181 },
  "5279": { x: 467, y: 182 },
  "5296": { x: 467, y: 182 },
  "5311": { x: 467, y: 182 },
  "5329": { x: 467, y: 182 },
  "5345": { x: 467, y: 182 },
  "5365": { x: 466, y: 182 },
  "5378": { x: 466, y: 183 },
  "5395": { x: 466, y: 183 },
  "5411": { x: 466, y: 183 },
  "5428": { x: 466, y: 183 },
  "5445": { x: 466, y: 183 },
  "5461": { x: 466, y: 183 },
  "5479": { x: 466, y: 184 },
  "5563": { x: 466, y: 184 },
  "5636": { x: 466, y: 184 },
  "5692": { x: 465, y: 184 },
  "5729": { x: 465, y: 185 },
  "5746": { x: 465, y: 185 },
  "5761": { x: 465, y: 185 },
  "5779": { x: 465, y: 185 },
  "5795": { x: 464, y: 185 },
  "5812": { x: 464, y: 186 },
  "5829": { x: 464, y: 186 },
  "5845": { x: 464, y: 186 },
  "5861": { x: 464, y: 186 },
  "5879": { x: 463, y: 186 },
  "5896": { x: 463, y: 187 },
  "5911": { x: 463, y: 187 },
  "5928": { x: 462, y: 187 },
  "5945": { x: 462, y: 187 },
  "5994": { x: 462, y: 187 },
  "6023": { x: 462, y: 187 },
  "6482": { x: 462, y: 187 },
  "6557": { x: 462, y: 188 },
  "6596": { x: 462, y: 188 },
  "6612": { x: 462, y: 188 },
  "6984": { x: 462, y: 188 },
  "6995": { x: 462, y: 188 },
  "7024": { x: 462, y: 189 },
  "7062": { x: 462, y: 189 },
  "7079": { x: 461, y: 189 },
  "7096": { x: 461, y: 189 },
  "7113": { x: 461, y: 189 },
  "7129": { x: 461, y: 190 },
  "7146": { x: 461, y: 190 },
  "7195": { x: 461, y: 190 },
  "7225": { x: 461, y: 190 },
  "7262": { x: 461, y: 191 },
  "7516": { x: 461, y: 190 },
  "7540": { x: 461, y: 190 },
  "7578": { x: 461, y: 190 },
  "8501": { x: 461, y: 190 },
  "9420": { x: 461, y: 190 },
  "9743": { x: 461, y: 190 },
  "9779": { x: 461, y: 189 },
  "10131": { x: 461, y: 190 },
  "10180": { x: 461, y: 190 },
  "10196": { x: 461, y: 190 },
  "10228": { x: 461, y: 190 },
  "10236": { x: 461, y: 190 },
  "10247": { x: 461, y: 191 },
  "10269": { x: 461, y: 191 },
  "10280": { x: 462, y: 191 },
  "10297": { x: 462, y: 191 },
  "10313": { x: 462, y: 191 },
  "10331": { x: 462, y: 192 },
  "10347": { x: 462, y: 192 },
  "10364": { x: 462, y: 192 },
  "10380": { x: 462, y: 193 },
  "10396": { x: 462, y: 193 },
  "10414": { x: 462, y: 193 },
  "10430": { x: 462, y: 194 },
  "10446": { x: 462, y: 194 },
  "10464": { x: 463, y: 194 },
  "10480": { x: 463, y: 194 },
  "10502": { x: 463, y: 194 },
  "10525": { x: 463, y: 195 },
  "10564": { x: 463, y: 195 },
  "10580": { x: 463, y: 195 },
  "10597": { x: 463, y: 195 },
  "10613": { x: 463, y: 196 },
  "10630": { x: 463, y: 196 },
  "10648": { x: 463, y: 196 },
  "10668": { x: 464, y: 197 },
  "10683": { x: 464, y: 197 },
  "10700": { x: 464, y: 197 },
  "10715": { x: 464, y: 197 },
  "10731": { x: 464, y: 198 },
  "10747": { x: 464, y: 198 },
  "10766": { x: 464, y: 199 },
  "10781": { x: 464, y: 199 },
  "10797": { x: 464, y: 199 },
  "10814": { x: 464, y: 200 },
  "10831": { x: 464, y: 200 },
  "10848": { x: 464, y: 200 },
  "10864": { x: 465, y: 200 },
  "10880": { x: 465, y: 201 },
  "10897": { x: 465, y: 201 },
  "10947": { x: 465, y: 201 },
  "10964": { x: 465, y: 201 },
  "11035": { x: 465, y: 201 },
  "11081": { x: 466, y: 201 },
  "11097": { x: 466, y: 201 },
  "11148": { x: 466, y: 201 },
  "11172": { x: 466, y: 201 },
  "11188": { x: 466, y: 201 },
  "11231": { x: 466, y: 201 },
  "11253": { x: 467, y: 202 },
  "11277": { x: 467, y: 202 },
  "11285": { x: 467, y: 202 },
  "11301": { x: 467, y: 202 },
  "11317": { x: 467, y: 202 },
  "11332": { x: 467, y: 202 },
  "11348": { x: 467, y: 203 },
  "11363": { x: 468, y: 203 },
  "11380": { x: 468, y: 203 },
  "11398": { x: 468, y: 203 },
  "11414": { x: 468, y: 203 },
  "11430": { x: 468, y: 203 },
  "11447": { x: 468, y: 204 },
  "11471": { x: 469, y: 204 },
  "11495": { x: 469, y: 204 },
  "11503": { x: 469, y: 204 },
  "11519": { x: 469, y: 204 },
  "11530": { x: 469, y: 204 },
  "11547": { x: 469, y: 205 },
  "11565": { x: 469, y: 205 },
  "11582": { x: 469, y: 205 },
  "11598": { x: 470, y: 205 },
  "11614": { x: 470, y: 205 },
  "11631": { x: 470, y: 205 },
  "11647": { x: 470, y: 205 },
  "11663": { x: 470, y: 206 },
  "11681": { x: 470, y: 206 },
  "11697": { x: 470, y: 206 },
  "11714": { x: 471, y: 206 },
  "11737": { x: 471, y: 206 },
  "11781": { x: 471, y: 207 },
  "11798": { x: 471, y: 207 },
  "11814": { x: 471, y: 207 },
  "11834": { x: 471, y: 207 },
  "11852": { x: 471, y: 207 },
  "11874": { x: 471, y: 207 },
  "11923": { x: 471, y: 208 },
  "11965": { x: 472, y: 208 },
  "11981": { x: 472, y: 208 },
  "12003": { x: 472, y: 208 },
  "12014": { x: 472, y: 208 },
  "12031": { x: 472, y: 209 },
  "12048": { x: 472, y: 209 },
  "12064": { x: 472, y: 209 },
  "12080": { x: 472, y: 209 },
  "12097": { x: 472, y: 209 },
  "12114": { x: 472, y: 209 },
  "12131": { x: 472, y: 210 },
  "12147": { x: 472, y: 210 },
  "12164": { x: 472, y: 210 },
  "12181": { x: 473, y: 211 },
  "12197": { x: 473, y: 211 },
  "12214": { x: 473, y: 211 },
  "12230": { x: 473, y: 212 },
  "12247": { x: 473, y: 212 },
  "12264": { x: 473, y: 212 },
  "12281": { x: 473, y: 213 },
  "12297": { x: 473, y: 213 },
  "12314": { x: 473, y: 213 },
  "12331": { x: 473, y: 214 },
  "12348": { x: 474, y: 214 },
  "12375": { x: 474, y: 214 },
  "12391": { x: 474, y: 215 },
  "12407": { x: 474, y: 215 },
  "12414": { x: 474, y: 215 },
  "12432": { x: 474, y: 215 },
  "12447": { x: 474, y: 216 },
  "12464": { x: 474, y: 216 },
  "12481": { x: 474, y: 216 },
  "12498": { x: 474, y: 217 },
  "12515": { x: 474, y: 217 },
  "12531": { x: 474, y: 217 },
  "12548": { x: 474, y: 218 },
  "12564": { x: 474, y: 218 },
  "12582": { x: 474, y: 218 },
  "12598": { x: 474, y: 219 },
  "13077": { x: 474, y: 219 },
  "13521": { x: 474, y: 219 },
  "13578": { x: 474, y: 219 },
  "13634": { x: 473, y: 219 },
  "13691": { x: 473, y: 219 },
  "13732": { x: 473, y: 219 },
  "13782": { x: 473, y: 219 },
  "13803": { x: 472, y: 219 },
  "13848": { x: 472, y: 219 },
  "13900": { x: 472, y: 219 },
  "14265": { x: 472, y: 219 },
  "14530": { x: 471, y: 219 },
  "14571": { x: 471, y: 219 },
  "14614": { x: 471, y: 219 },
  "14665": { x: 470, y: 219 },
  "14700": { x: 470, y: 219 },
  "14749": { x: 470, y: 219 },
  "14772": { x: 470, y: 219 },
  "14788": { x: 469, y: 219 },
  "14812": { x: 469, y: 219 },
  "14853": { x: 469, y: 219 },
  "14876": { x: 469, y: 219 },
  "14915": { x: 469, y: 219 },
  "14941": { x: 468, y: 219 },
  "14990": { x: 468, y: 219 },
  "15039": { x: 468, y: 219 },
  "15063": { x: 468, y: 219 },
  "15100": { x: 467, y: 219 },
  "15116": { x: 467, y: 219 },
  "15133": { x: 467, y: 219 },
  "15151": { x: 467, y: 219 },
  "15199": { x: 466, y: 219 },
  "15216": { x: 466, y: 219 },
  "15232": { x: 466, y: 219 },
  "15263": { x: 466, y: 219 },
  "15271": { x: 465, y: 219 },
  "15288": { x: 465, y: 219 },
  "15305": { x: 465, y: 219 },
  "15329": { x: 465, y: 219 },
  "15345": { x: 464, y: 219 },
  "15363": { x: 464, y: 219 },
  "15377": { x: 464, y: 219 },
  "15394": { x: 464, y: 219 },
  "15410": { x: 463, y: 219 },
  "15418": { x: 463, y: 219 },
  "15434": { x: 463, y: 219 },
  "15458": { x: 463, y: 219 },
  "15499": { x: 463, y: 220 },
  "15522": { x: 462, y: 220 },
  "15571": { x: 462, y: 220 },
  "15616": { x: 462, y: 220 },
  "15634": { x: 462, y: 220 },
  "15649": { x: 462, y: 220 },
  "15668": { x: 461, y: 220 },
  "15716": { x: 461, y: 220 },
  "15765": { x: 461, y: 220 },
  "15821": { x: 461, y: 220 },
  "15911": { x: 461, y: 220 },
  "15961": { x: 460, y: 220 },
  "15999": { x: 460, y: 220 },
  "16023": { x: 460, y: 220 },
  "16046": { x: 460, y: 220 },
  "16087": { x: 459, y: 220 },
  "16160": { x: 459, y: 220 },
  "16167": { x: 459, y: 220 },
  "16217": { x: 459, y: 220 },
  "16393": { x: 459, y: 220 },
  "16401": { x: 459, y: 220 },
  "16426": { x: 460, y: 220 },
  "16466": { x: 460, y: 220 },
  "16517": { x: 460, y: 220 },
  "16540": { x: 460, y: 220 },
  "16583": { x: 460, y: 220 },
  "16633": { x: 461, y: 220 },
  "16661": { x: 461, y: 220 },
  "16677": { x: 461, y: 220 },
  "16693": { x: 461, y: 220 },
  "16742": { x: 461, y: 220 },
  "16782": { x: 462, y: 220 },
  "17090": { x: 462, y: 220 },
  "17133": { x: 462, y: 220 },
  "17184": { x: 462, y: 220 },
  "17258": { x: 463, y: 220 },
  "17299": { x: 463, y: 220 },
  "17350": { x: 463, y: 220 },
  "17401": { x: 463, y: 220 },
  "17450": { x: 464, y: 220 },
  "17758": { x: 464, y: 220 },
  "17799": { x: 464, y: 220 }
};

const path5 = {
  "811": { x: 440, y: 267 },
  "849": { x: 440, y: 267 },
  "899": { x: 441, y: 267 },
  "917": { x: 441, y: 267 },
  "933": { x: 441, y: 267 },
  "957": { x: 441, y: 267 },
  "967": { x: 441, y: 267 },
  "983": { x: 442, y: 267 },
  "999": { x: 442, y: 267 },
  "1016": { x: 442, y: 267 },
  "1033": { x: 442, y: 267 },
  "1053": { x: 443, y: 267 },
  "1102": { x: 443, y: 267 },
  "1126": { x: 443, y: 268 },
  "1166": { x: 443, y: 268 },
  "1182": { x: 443, y: 268 },
  "1199": { x: 444, y: 268 },
  "1216": { x: 444, y: 268 },
  "1233": { x: 444, y: 268 },
  "1249": { x: 444, y: 268 },
  "1266": { x: 444, y: 268 },
  "1282": { x: 445, y: 268 },
  "1300": { x: 445, y: 269 },
  "1317": { x: 445, y: 269 },
  "1343": { x: 445, y: 269 },
  "1360": { x: 445, y: 269 },
  "1392": { x: 445, y: 269 },
  "1457": { x: 446, y: 269 },
  "2168": { x: 446, y: 269 },
  "2183": { x: 446, y: 269 },
  "2201": { x: 446, y: 269 },
  "2223": { x: 446, y: 270 },
  "2267": { x: 446, y: 270 },
  "2322": { x: 447, y: 270 },
  "2370": { x: 447, y: 270 },
  "2383": { x: 447, y: 270 },
  "2401": { x: 447, y: 270 },
  "2450": { x: 447, y: 271 },
  "2467": { x: 447, y: 271 },
  "2490": { x: 447, y: 271 },
  "2539": { x: 448, y: 271 },
  "2635": { x: 448, y: 271 },
  "2650": { x: 448, y: 271 },
  "2911": { x: 448, y: 271 },
  "2927": { x: 448, y: 272 },
  "2942": { x: 448, y: 272 },
  "2967": { x: 448, y: 272 },
  "2984": { x: 448, y: 272 },
  "3000": { x: 448, y: 273 },
  "3022": { x: 448, y: 273 },
  "3067": { x: 448, y: 273 },
  "3083": { x: 448, y: 273 },
  "3101": { x: 448, y: 273 },
  "3117": { x: 448, y: 274 },
  "3134": { x: 447, y: 274 },
  "3150": { x: 447, y: 274 },
  "3167": { x: 447, y: 274 },
  "3185": { x: 447, y: 274 },
  "3201": { x: 447, y: 274 },
  "3217": { x: 447, y: 275 },
  "3237": { x: 447, y: 275 },
  "3251": { x: 447, y: 275 },
  "3273": { x: 447, y: 275 },
  "3284": { x: 446, y: 275 },
  "3306": { x: 446, y: 276 },
  "3318": { x: 446, y: 276 },
  "3334": { x: 446, y: 276 },
  "3351": { x: 446, y: 276 },
  "3371": { x: 446, y: 276 },
  "3417": { x: 446, y: 277 },
  "3468": { x: 445, y: 277 },
  "3814": { x: 445, y: 277 },
  "3851": { x: 445, y: 277 },
  "3870": { x: 445, y: 277 },
  "3895": { x: 445, y: 278 },
  "3920": { x: 445, y: 278 },
  "3934": { x: 445, y: 278 },
  "3951": { x: 445, y: 278 },
  "3966": { x: 445, y: 278 },
  "3985": { x: 445, y: 279 },
  "4008": { x: 445, y: 279 },
  "4018": { x: 445, y: 279 },
  "4034": { x: 445, y: 279 },
  "4051": { x: 445, y: 280 },
  "4068": { x: 445, y: 280 },
  "4083": { x: 444, y: 280 },
  "4100": { x: 444, y: 281 },
  "4116": { x: 444, y: 281 },
  "4134": { x: 444, y: 281 },
  "4150": { x: 444, y: 282 },
  "4200": { x: 444, y: 282 },
  "4218": { x: 444, y: 282 },
  "4283": { x: 444, y: 282 },
  "4299": { x: 444, y: 282 },
  "4315": { x: 444, y: 283 },
  "4331": { x: 444, y: 283 },
  "4368": { x: 443, y: 283 },
  "4384": { x: 443, y: 283 },
  "4403": { x: 443, y: 284 },
  "4450": { x: 443, y: 284 },
  "4477": { x: 443, y: 284 },
  "4492": { x: 443, y: 284 },
  "4501": { x: 443, y: 284 },
  "4524": { x: 443, y: 284 },
  "4540": { x: 443, y: 285 },
  "4552": { x: 443, y: 285 },
  "4568": { x: 443, y: 285 },
  "4584": { x: 443, y: 285 },
  "4601": { x: 442, y: 285 },
  "4654": { x: 442, y: 286 },
  "4701": { x: 442, y: 286 },
  "4718": { x: 442, y: 286 },
  "4734": { x: 442, y: 286 },
  "4759": { x: 442, y: 287 },
  "4768": { x: 442, y: 287 },
  "4784": { x: 442, y: 287 },
  "4814": { x: 442, y: 287 },
  "4830": { x: 442, y: 287 },
  "4847": { x: 442, y: 288 },
  "4854": { x: 442, y: 288 },
  "4868": { x: 442, y: 288 },
  "4887": { x: 442, y: 288 },
  "4935": { x: 441, y: 288 },
  "4950": { x: 441, y: 289 },
  "4968": { x: 441, y: 289 },
  "4984": { x: 441, y: 289 },
  "5001": { x: 441, y: 289 },
  "5017": { x: 441, y: 289 },
  "5041": { x: 441, y: 290 },
  "5085": { x: 441, y: 290 },
  "5101": { x: 441, y: 290 },
  "5118": { x: 441, y: 290 },
  "5138": { x: 441, y: 290 },
  "5161": { x: 441, y: 291 },
  "5177": { x: 441, y: 291 },
  "5218": { x: 441, y: 291 },
  "5235": { x: 441, y: 291 },
  "5267": { x: 441, y: 291 },
  "5318": { x: 441, y: 292 },
  "5348": { x: 440, y: 292 },
  "5356": { x: 440, y: 292 },
  "5421": { x: 440, y: 292 },
  "5469": { x: 440, y: 292 },
  "5519": { x: 440, y: 292 },
  "6304": { x: 440, y: 293 },
  "6329": { x: 440, y: 293 },
  "6368": { x: 440, y: 293 },
  "6385": { x: 440, y: 293 },
  "6400": { x: 440, y: 294 },
  "6419": { x: 440, y: 294 },
  "6468": { x: 440, y: 294 },
  "6486": { x: 440, y: 294 },
  "6506": { x: 439, y: 294 },
  "6530": { x: 439, y: 294 },
  "6538": { x: 439, y: 294 },
  "6562": { x: 439, y: 294 },
  "6587": { x: 439, y: 294 },
  "6611": { x: 438, y: 294 },
  "6619": { x: 438, y: 295 },
  "6635": { x: 438, y: 295 },
  "6651": { x: 438, y: 295 },
  "6668": { x: 437, y: 295 },
  "6719": { x: 437, y: 295 },
  "6749": { x: 437, y: 294 },
  "6788": { x: 437, y: 294 },
  "6813": { x: 437, y: 294 },
  "6852": { x: 437, y: 294 },
  "6868": { x: 437, y: 294 },
  "6885": { x: 437, y: 294 },
  "6902": { x: 436, y: 294 },
  "6920": { x: 436, y: 293 },
  "6936": { x: 436, y: 293 },
  "6951": { x: 436, y: 293 },
  "6969": { x: 436, y: 293 },
  "6985": { x: 436, y: 293 },
  "7002": { x: 436, y: 292 },
  "7022": { x: 436, y: 292 },
  "7048": { x: 435, y: 292 },
  "7085": { x: 435, y: 292 },
  "7102": { x: 435, y: 292 },
  "7119": { x: 435, y: 291 },
  "7144": { x: 435, y: 291 },
  "7208": { x: 435, y: 291 },
  "7417": { x: 435, y: 291 },
  "7452": { x: 435, y: 292 },
  "7482": { x: 435, y: 292 },
  "7498": { x: 435, y: 292 },
  "7514": { x: 435, y: 292 },
  "7553": { x: 436, y: 292 },
  "7579": { x: 436, y: 292 },
  "7628": { x: 436, y: 292 },
  "7670": { x: 436, y: 292 },
  "7741": { x: 437, y: 292 },
  "7838": { x: 437, y: 292 },
  "8105": { x: 437, y: 292 },
  "8128": { x: 437, y: 292 },
  "8144": { x: 438, y: 292 },
  "8160": { x: 438, y: 293 },
  "8177": { x: 438, y: 293 },
  "8193": { x: 438, y: 293 },
  "8209": { x: 438, y: 293 },
  "8220": { x: 439, y: 293 },
  "8236": { x: 439, y: 293 },
  "8253": { x: 439, y: 293 },
  "8269": { x: 439, y: 293 },
  "8290": { x: 440, y: 293 },
  "8336": { x: 440, y: 293 },
  "8362": { x: 440, y: 293 },
  "8404": { x: 440, y: 294 },
  "8420": { x: 440, y: 294 },
  "8476": { x: 441, y: 294 },
  "8520": { x: 441, y: 294 },
  "8548": { x: 441, y: 294 },
  "8556": { x: 441, y: 294 },
  "8603": { x: 441, y: 294 },
  "8653": { x: 442, y: 294 },
  "8668": { x: 442, y: 294 },
  "8720": { x: 442, y: 294 },
  "8742": { x: 442, y: 294 },
  "8787": { x: 442, y: 294 },
  "8814": { x: 443, y: 294 },
  "8853": { x: 443, y: 294 },
  "8927": { x: 443, y: 294 },
  "9016": { x: 443, y: 294 },
  "9114": { x: 443, y: 294 },
  "9129": { x: 443, y: 294 },
  "9726": { x: 443, y: 294 },
  "9783": { x: 443, y: 294 },
  "9798": { x: 443, y: 294 },
  "9837": { x: 443, y: 294 },
  "9853": { x: 443, y: 294 },
  "9903": { x: 442, y: 294 },
  "9919": { x: 442, y: 294 },
  "9944": { x: 442, y: 294 },
  "9969": { x: 442, y: 294 },
  "10003": { x: 441, y: 294 },
  "10025": { x: 441, y: 294 },
  "10090": { x: 441, y: 294 },
  "10138": { x: 441, y: 294 },
  "10161": { x: 440, y: 294 },
  "10186": { x: 440, y: 294 },
  "10251": { x: 440, y: 294 },
  "10299": { x: 440, y: 294 },
  "10315": { x: 440, y: 295 },
  "10323": { x: 440, y: 295 },
  "10339": { x: 440, y: 295 },
  "10353": { x: 440, y: 295 },
  "10374": { x: 440, y: 296 },
  "10387": { x: 440, y: 296 },
  "10403": { x: 439, y: 296 },
  "10421": { x: 439, y: 297 },
  "10437": { x: 439, y: 297 },
  "10454": { x: 439, y: 297 },
  "10470": { x: 439, y: 298 },
  "10487": { x: 439, y: 298 },
  "10504": { x: 439, y: 298 },
  "10520": { x: 439, y: 298 },
  "10540": { x: 439, y: 299 },
  "10565": { x: 439, y: 299 },
  "10582": { x: 439, y: 299 },
  "10598": { x: 439, y: 299 },
  "10606": { x: 439, y: 299 },
  "10622": { x: 439, y: 300 },
  "10671": { x: 439, y: 300 },
  "10687": { x: 439, y: 300 },
  "10703": { x: 439, y: 300 },
  "10727": { x: 439, y: 301 },
  "10752": { x: 439, y: 301 },
  "10768": { x: 439, y: 301 },
  "10784": { x: 439, y: 301 },
  "10800": { x: 439, y: 302 },
  "10816": { x: 439, y: 302 },
  "10823": { x: 439, y: 302 },
  "10840": { x: 439, y: 302 },
  "10856": { x: 439, y: 302 },
  "10869": { x: 439, y: 303 },
  "10887": { x: 439, y: 303 },
  "10903": { x: 438, y: 303 },
  "10920": { x: 438, y: 304 },
  "10937": { x: 438, y: 304 },
  "10953": { x: 438, y: 304 },
  "10971": { x: 438, y: 305 },
  "10987": { x: 437, y: 305 },
  "11004": { x: 437, y: 305 },
  "11020": { x: 437, y: 306 },
  "11037": { x: 437, y: 306 },
  "11054": { x: 437, y: 306 },
  "11070": { x: 436, y: 306 },
  "11087": { x: 436, y: 306 },
  "11137": { x: 436, y: 307 },
  "11154": { x: 436, y: 307 },
  "11203": { x: 436, y: 307 },
  "11221": { x: 436, y: 307 },
  "11251": { x: 436, y: 307 },
  "11267": { x: 436, y: 307 },
  "11305": { x: 436, y: 307 },
  "11320": { x: 435, y: 308 },
  "11337": { x: 435, y: 308 },
  "11354": { x: 435, y: 308 },
  "11370": { x: 435, y: 308 },
  "11386": { x: 435, y: 309 },
  "11403": { x: 435, y: 309 },
  "11422": { x: 434, y: 309 },
  "11445": { x: 434, y: 309 },
  "11453": { x: 434, y: 309 },
  "11471": { x: 434, y: 310 },
  "11494": { x: 434, y: 310 },
  "11518": { x: 434, y: 310 },
  "11534": { x: 434, y: 310 },
  "11571": { x: 433, y: 311 },
  "11599": { x: 433, y: 311 },
  "11638": { x: 433, y: 311 },
  "11654": { x: 433, y: 311 },
  "11672": { x: 433, y: 311 },
  "11696": { x: 433, y: 311 },
  "11785": { x: 433, y: 311 },
  "11821": { x: 432, y: 311 },
  "11837": { x: 432, y: 311 },
  "11856": { x: 432, y: 311 },
  "11872": { x: 432, y: 311 },
  "11889": { x: 431, y: 311 },
  "11904": { x: 431, y: 311 },
  "11920": { x: 431, y: 311 },
  "11936": { x: 431, y: 311 },
  "11954": { x: 430, y: 311 },
  "11971": { x: 430, y: 310 },
  "11988": { x: 430, y: 310 },
  "12005": { x: 430, y: 310 },
  "12021": { x: 429, y: 310 },
  "12072": { x: 429, y: 310 },
  "12091": { x: 429, y: 310 },
  "12140": { x: 429, y: 310 },
  "12188": { x: 428, y: 310 },
  "12213": { x: 428, y: 310 },
  "12220": { x: 428, y: 309 },
  "12237": { x: 428, y: 309 },
  "12255": { x: 428, y: 309 },
  "12277": { x: 427, y: 309 },
  "12292": { x: 427, y: 309 },
  "12309": { x: 427, y: 309 },
  "12325": { x: 427, y: 309 },
  "12350": { x: 426, y: 309 },
  "12388": { x: 426, y: 309 },
  "12406": { x: 426, y: 309 },
  "12423": { x: 426, y: 309 },
  "12437": { x: 426, y: 309 },
  "12455": { x: 425, y: 309 },
  "12471": { x: 425, y: 309 },
  "12488": { x: 425, y: 309 },
  "12505": { x: 425, y: 309 },
  "12526": { x: 424, y: 308 },
  "12542": { x: 424, y: 308 },
  "12560": { x: 424, y: 308 },
  "12570": { x: 424, y: 308 },
  "12588": { x: 424, y: 308 },
  "12605": { x: 423, y: 308 },
  "12624": { x: 423, y: 308 },
  "12649": { x: 423, y: 308 },
  "12657": { x: 423, y: 308 },
  "12704": { x: 423, y: 308 },
  "12721": { x: 422, y: 308 },
  "12745": { x: 422, y: 308 },
  "12787": { x: 422, y: 308 },
  "12838": { x: 422, y: 308 },
  "12858": { x: 422, y: 308 },
  "12914": { x: 422, y: 307 },
  "13141": { x: 421, y: 307 },
  "13188": { x: 421, y: 307 },
  "13205": { x: 421, y: 307 },
  "13222": { x: 420, y: 307 },
  "13238": { x: 420, y: 307 },
  "13255": { x: 420, y: 307 },
  "13272": { x: 419, y: 307 },
  "13289": { x: 419, y: 307 },
  "13310": { x: 419, y: 307 },
  "13326": { x: 419, y: 307 },
  "13338": { x: 419, y: 307 },
  "13355": { x: 418, y: 307 },
  "13385": { x: 418, y: 307 },
  "13422": { x: 418, y: 307 },
  "13438": { x: 418, y: 307 },
  "13455": { x: 417, y: 307 },
  "13471": { x: 417, y: 307 },
  "13496": { x: 417, y: 307 },
  "13539": { x: 417, y: 307 },
  "13589": { x: 416, y: 307 },
  "13639": { x: 416, y: 307 },
  "13666": { x: 416, y: 307 },
  "13704": { x: 416, y: 307 },
  "13722": { x: 415, y: 307 },
  "13737": { x: 415, y: 307 },
  "13754": { x: 415, y: 307 },
  "13772": { x: 415, y: 307 },
  "13788": { x: 414, y: 306 },
  "13805": { x: 414, y: 306 },
  "13821": { x: 414, y: 306 },
  "13838": { x: 414, y: 306 },
  "13855": { x: 414, y: 306 },
  "13870": { x: 413, y: 306 },
  "13889": { x: 413, y: 306 },
  "13906": { x: 413, y: 306 },
  "13923": { x: 413, y: 306 },
  "14020": { x: 413, y: 306 },
  "14055": { x: 413, y: 305 },
  "14071": { x: 412, y: 305 },
  "14093": { x: 412, y: 305 },
  "14139": { x: 412, y: 305 },
  "14155": { x: 412, y: 305 },
  "14172": { x: 412, y: 305 },
  "14188": { x: 412, y: 305 },
  "14206": { x: 411, y: 304 },
  "14255": { x: 411, y: 304 },
  "14278": { x: 411, y: 304 },
  "14326": { x: 411, y: 304 },
  "14342": { x: 411, y: 304 },
  "14358": { x: 411, y: 303 },
  "14382": { x: 411, y: 303 },
  "14422": { x: 411, y: 303 },
  "14594": { x: 411, y: 303 },
  "14605": { x: 412, y: 303 },
  "14623": { x: 414, y: 303 },
  "14639": { x: 415, y: 303 },
  "14655": { x: 416, y: 303 },
  "14673": { x: 417, y: 303 },
  "14689": { x: 418, y: 303 },
  "14705": { x: 418, y: 303 },
  "14722": { x: 419, y: 303 },
  "14738": { x: 419, y: 303 },
  "14755": { x: 419, y: 303 },
  "14788": { x: 419, y: 303 },
  "14819": { x: 420, y: 303 },
  "14901": { x: 420, y: 303 },
  "14938": { x: 420, y: 303 },
  "14965": { x: 420, y: 303 },
  "15006": { x: 421, y: 303 },
  "15022": { x: 421, y: 303 },
  "15040": { x: 421, y: 303 },
  "15055": { x: 421, y: 303 },
  "15072": { x: 422, y: 303 },
  "15089": { x: 422, y: 304 },
  "15105": { x: 423, y: 304 },
  "15123": { x: 423, y: 304 },
  "15139": { x: 424, y: 304 },
  "15156": { x: 424, y: 305 },
  "15172": { x: 425, y: 305 },
  "15189": { x: 425, y: 305 },
  "15205": { x: 426, y: 305 },
  "15222": { x: 426, y: 305 },
  "15238": { x: 426, y: 305 },
  "15256": { x: 426, y: 305 },
  "15273": { x: 427, y: 306 },
  "15288": { x: 427, y: 306 },
  "15306": { x: 427, y: 306 },
  "15328": { x: 427, y: 306 },
  "15344": { x: 427, y: 306 },
  "15360": { x: 427, y: 306 },
  "15383": { x: 428, y: 306 },
  "15400": { x: 428, y: 306 },
  "15418": { x: 428, y: 306 },
  "15433": { x: 428, y: 307 },
  "15440": { x: 428, y: 307 },
  "15457": { x: 429, y: 307 },
  "15482": { x: 429, y: 307 },
  "15489": { x: 429, y: 307 },
  "15506": { x: 429, y: 307 },
  "15522": { x: 429, y: 307 },
  "15539": { x: 429, y: 307 },
  "15555": { x: 430, y: 307 },
  "15571": { x: 430, y: 307 },
  "15588": { x: 430, y: 307 },
  "15605": { x: 430, y: 307 },
  "15622": { x: 430, y: 307 },
  "15639": { x: 431, y: 308 },
  "15657": { x: 431, y: 308 },
  "15672": { x: 431, y: 308 },
  "15690": { x: 431, y: 308 },
  "15706": { x: 431, y: 308 },
  "15723": { x: 432, y: 308 },
  "15738": { x: 432, y: 308 },
  "15755": { x: 432, y: 308 },
  "15772": { x: 432, y: 309 },
  "15790": { x: 432, y: 309 },
  "15806": { x: 432, y: 309 },
  "15823": { x: 433, y: 309 },
  "15845": { x: 433, y: 309 },
  "15857": { x: 433, y: 309 },
  "15873": { x: 433, y: 309 },
  "15893": { x: 433, y: 309 },
  "15909": { x: 433, y: 309 },
  "15956": { x: 433, y: 310 },
  "15972": { x: 434, y: 310 },
  "16022": { x: 434, y: 310 },
  "16073": { x: 434, y: 310 },
  "16089": { x: 434, y: 310 },
  "16119": { x: 434, y: 310 },
  "16199": { x: 435, y: 310 },
  "16231": { x: 435, y: 310 },
  "16572": { x: 435, y: 310 },
  "16628": { x: 435, y: 311 },
  "16640": { x: 435, y: 311 },
  "16655": { x: 435, y: 311 },
  "16673": { x: 435, y: 311 },
  "16690": { x: 435, y: 311 },
  "16706": { x: 435, y: 311 },
  "16724": { x: 435, y: 311 },
  "16749": { x: 436, y: 312 },
  "16765": { x: 436, y: 312 },
  "16781": { x: 436, y: 312 },
  "16789": { x: 436, y: 312 },
  "16807": { x: 436, y: 313 },
  "16824": { x: 436, y: 313 },
  "16840": { x: 436, y: 313 },
  "16856": { x: 436, y: 314 },
  "16873": { x: 436, y: 314 },
  "16890": { x: 436, y: 314 },
  "16906": { x: 436, y: 314 },
  "16923": { x: 436, y: 315 },
  "16939": { x: 436, y: 315 },
  "16956": { x: 436, y: 315 },
  "16973": { x: 436, y: 315 },
  "16989": { x: 436, y: 316 },
  "17007": { x: 436, y: 316 },
  "17023": { x: 436, y: 316 },
  "17040": { x: 436, y: 317 },
  "17071": { x: 436, y: 317 },
  "17107": { x: 436, y: 317 },
  "17124": { x: 436, y: 317 },
  "17140": { x: 436, y: 317 },
  "17157": { x: 435, y: 317 },
  "17173": { x: 435, y: 317 },
  "17190": { x: 435, y: 317 },
  "17217": { x: 435, y: 318 },
  "17256": { x: 435, y: 318 },
  "17273": { x: 435, y: 318 },
  "17297": { x: 435, y: 318 },
  "17340": { x: 434, y: 318 },
  "17362": { x: 434, y: 318 },
  "17373": { x: 434, y: 318 },
  "17422": { x: 434, y: 318 },
  "17439": { x: 434, y: 318 },
  "17457": { x: 434, y: 319 },
  "17484": { x: 434, y: 319 },
  "17547": { x: 434, y: 319 },
  "17563": { x: 434, y: 319 },
  "17573": { x: 433, y: 319 },
  "17596": { x: 433, y: 320 },
  "17620": { x: 433, y: 320 },
  "17628": { x: 433, y: 320 },
  "17673": { x: 433, y: 320 },
  "17690": { x: 433, y: 320 },
  "17706": { x: 432, y: 320 },
  "17724": { x: 432, y: 321 },
  "17739": { x: 432, y: 321 },
  "17757": { x: 432, y: 321 },
  "17782": { x: 431, y: 321 },
  "17790": { x: 431, y: 321 },
  "17807": { x: 431, y: 321 },
  "17824": { x: 431, y: 321 },
  "17840": { x: 431, y: 322 },
  "17857": { x: 431, y: 322 },
  "17886": { x: 430, y: 322 },
  "17894": { x: 430, y: 322 },
  "17940": { x: 430, y: 322 },
  "17957": { x: 430, y: 322 },
  "17976": { x: 430, y: 322 },
  "17991": { x: 430, y: 322 },
  "18015": { x: 430, y: 323 },
  "18024": { x: 430, y: 323 },
  "18048": { x: 430, y: 323 },
  "18096": { x: 429, y: 323 },
  "18140": { x: 429, y: 323 },
  "18156": { x: 429, y: 323 },
  "18173": { x: 429, y: 324 },
  "18192": { x: 429, y: 324 },
  "18216": { x: 429, y: 324 },
  "18225": { x: 429, y: 324 },
  "18241": { x: 429, y: 324 },
  "18257": { x: 429, y: 325 },
  "18273": { x: 429, y: 325 },
  "18299": { x: 429, y: 325 },
  "18323": { x: 428, y: 325 },
  "18340": { x: 428, y: 325 },
  "18396": { x: 428, y: 326 },
  "18439": { x: 428, y: 326 },
  "18476": { x: 428, y: 326 },
  "18523": { x: 428, y: 326 },
  "18541": { x: 428, y: 326 },
  "18556": { x: 428, y: 327 },
  "18573": { x: 428, y: 327 },
  "18590": { x: 428, y: 327 },
  "18608": { x: 428, y: 327 },
  "18628": { x: 428, y: 327 },
  "18640": { x: 428, y: 327 },
  "18661": { x: 428, y: 327 },
  "18686": { x: 428, y: 328 },
  "18702": { x: 428, y: 328 },
  "18710": { x: 427, y: 328 },
  "18724": { x: 427, y: 328 },
  "18741": { x: 427, y: 328 },
  "18757": { x: 427, y: 329 },
  "18774": { x: 427, y: 329 },
  "18791": { x: 427, y: 329 },
  "18807": { x: 427, y: 330 },
  "18824": { x: 427, y: 330 },
  "18839": { x: 427, y: 331 },
  "18856": { x: 427, y: 331 },
  "18874": { x: 427, y: 331 },
  "18892": { x: 427, y: 331 },
  "18908": { x: 426, y: 332 },
  "18958": { x: 426, y: 332 },
  "19017": { x: 426, y: 332 },
  "19057": { x: 426, y: 332 },
  "19073": { x: 426, y: 333 },
  "19089": { x: 426, y: 333 },
  "19107": { x: 426, y: 333 },
  "19124": { x: 426, y: 333 },
  "19139": { x: 426, y: 334 },
  "19158": { x: 426, y: 334 },
  "19174": { x: 426, y: 335 },
  "19190": { x: 426, y: 335 },
  "19206": { x: 426, y: 335 },
  "19225": { x: 426, y: 336 },
  "19241": { x: 426, y: 336 },
  "19257": { x: 426, y: 336 },
  "19274": { x: 425, y: 337 },
  "19290": { x: 425, y: 337 },
  "19307": { x: 425, y: 338 },
  "19324": { x: 425, y: 338 },
  "19340": { x: 425, y: 339 },
  "19364": { x: 425, y: 339 },
  "19409": { x: 425, y: 339 },
  "19425": { x: 425, y: 339 },
  "19443": { x: 425, y: 339 }
};

export default [path1, path2, path3, path5];
